import { defineMessages } from 'react-intl-next';

export const messages: {
	close: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	newLozengeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	close: {
		id: 'company-hub-common.config-panel.panel-close-button.close-label',
		defaultMessage: 'Close configuration panel',
		description: 'Accessibility text for the cross button to close the config panel',
	},
	newLozengeLabel: {
		id: 'company-hub-common.config-panel.new-lozenge-label',
		defaultMessage: 'NEW',
		description: 'A label indicating that this feature is new',
	},
});
